<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [width]="entry === FileSystemEntryE.Main || data ? '8.5rem' : '7.6rem'"
    id="create-file-system-slide-window"
    [loading]="loading"
    (onHide)="close()"
    (onShow)="onShow()">
    <n-header>
        <h1>{{data ? i18n.copyTitle : i18n.createTitle}}</h1>
        <n-help-link [key]="data ? 'fsCopy' : 'fsCreate'"></n-help-link>
        <n-checkbox id="storage_pool_create_advanced"
            *ngIf="!slideWindow?.showBatch"
            style="margin-left: auto;"
            [label]="i18n.advancedLab"
            [(ngModel)]="advanced">
        </n-checkbox>
    </n-header>

    <form [errorMessage]="errorMessage"
        [formGroup]="vm"
        class="common-form">
        <n-form-item [labelHide]="true">
            <div class="title-md">{{i18n.basicInfoLab}}</div>
        </n-form-item>
        <!-- 名称 -->
        <n-form-item [label]="i18n.nameLab"
        [required]="true">
        <input type="text"
            id="create-file-system-name"
            nInput
            formControlName="name"
            [placeholder]="errorMessage.name.rangeByteLength">
        </n-form-item>
        <!-- 租户 -->
        <n-form-item [label]="i18n.vStoreLab"
            [required]="!vstore || !vstore.value">
            <n-select #vstoreSelect
                id="vstore_dropdown"
                formControlName="vstoreItem"
                [rest]="vstoreRest"
                [filter]="true"
                [labelField]="'NAME'"
                [valueField]="'ID'"
                style="width: 3rem"
                (onChange)="onVstoreChange($event)"
                *ngIf="!vstore || !vstore.value">
            </n-select>
            <div class="n-form-item-text" *ngIf="vstore && vstore.value">{{vstore.label}}</div>
        </n-form-item>
        <!-- 描述 -->
        <ng-container *ngIf="advanced">
            <n-form-item [label]="i18n.descriptionLab">
                <textarea id="create-file-system-description"
                    nTextarea
                    formControlName="description"
                    [placeholder]="errorMessage.description.rangeByteLength">
                </textarea>
            </n-form-item>
        </ng-container>
        <!-- 存储池 -->
        <n-form-item [label]="i18n.storagePoolLab"
            [required]="true">
            <n-select #poolSelect
                id="create-file-system-storagepool"
                [options]="storagePoolOpts"
                formControlName="storagePool"
                (onChange)="onStoragePoolChange($event)">
            </n-select>
        </n-form-item>
        <!-- 安全模式 -->
        <n-form-item [label]="i18n.securityStyleLab"
            [required]="true"
            [helpContent]="i18n.securityTip">
            <n-select id="create-file-system-security-style"
                [options]="str.tempSecurityOpts"
                formControlName="securityStyle">
            </n-select>
            <p class="sub mt-5" *ngIf="str.showSecurityBottomTipItem.includes(vm.value.securityStyle) && !ProductConfig.isOnlySupportUnixSecurityStyle">
                {{i18n.securityStyleAllTip}}
            </p>
        </n-form-item>
        <!-- nas锁定策略 -->
        <n-form-item [label]="i18n.lockPolicyLab"
            *ngIf="vm.value.securityStyle === SecurityModeE.Native">
            <n-select id="create-file-system-nas-locking-policy"
                [options]="str.nasLockingPolicyOpts"
                formControlName="nasLockingPolicy">
            </n-select>
        </n-form-item>
        <!-- VAAI能力开关 -->
        <n-form-item *ngIf="ProductConfig.isSupportVAAISwitch && entry !== FileSystemEntryE.AuditLog"
            [label]="i18n.vaaiLab"
            [helpContent]="i18n.vaaiTip">
            <n-checkbox id="create-file-system-vaai"
                formControlName="vaaiSwitch"
                [label]="i18n.enable">
            </n-checkbox>
        </n-form-item>
        <!-- 容量与调优 -->
        <n-form-item [labelHide]="true">
            <div class="title-md mt-32">{{i18n.capAndTunningLab}}</div>
        </n-form-item>
        <n-form-item [label]="i18n.capacityLab"
            [helpContent]="i18n.createCapacityTip"
            required="true">
            <div class="interval-10">
                <n-capacity id="create-file-system-capacity"
                    style="width: 3rem"
                    [units]="['Sector', 'MB', 'GB', 'TB', 'PB']"
                    [nonDecimalUnits]="['Sector', 'MB']"
                    formControlName="capacity">
                </n-capacity>
                <span *ngIf="vm.value.capacity.unit === 'Sector'">
                    {{ vm.value.capacity.value | adaptUnit :'Sector'}}
                </span>
            </div>
            <n-tip *ngIf="capLossTips"
                [content]="capLossTips">
            </n-tip>
        </n-form-item>
        <!-- 容量阈值 -->
        <ng-container *ngIf="advanced">
            <n-form-item [label]="i18n.capacityThresholdWithUnitLab"
                [required]="true">
                <n-spinner id="create-file-system-capacity-threshold"
                    [min]="50"
                    [max]="99"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    formControlName="capacityThreshold">
                </n-spinner>
            </n-form-item>
        </ng-container>
        <!-- 快照空间比例（%） -->
        <n-form-item [label]="i18n.snapshotRate"
            [helpContent]="i18n.snapShotTips"
            [required]="true"
            *ngIf="!ProductConfig.isHideFsSnapshotFeature">
            <n-spinner id="create-file-system-snapshot-rate"
                [min]="str.snapshotMin"
                [max]="str.snapshotMax"
                [onlyInput]="true"
                [rangeTip]="true"
                formControlName="snapshotReserveper">
            </n-spinner>
        </n-form-item>
        <!-- 删除旧的只读快照 -->
        <n-form-item *ngIf="advanced && !ProductConfig.isHideFsSnapshotFeature"
            [helpContent]="i18n.delReadonlySnapshotTips"
            required="true"
            [label]="i18n.delReadonlySnapshot">
            <n-checkbox id="create-file-system-del-snapshot"
                formControlName="autodelSnapshotEnable"
                [label]="i18n.enable">
            </n-checkbox>
        </n-form-item>
        <!-- 容量自适应策略 -->
        <n-form-item *ngIf="advanced && !ProductConfig.isHideFsAutoScaling"
            [helpContent]="i18n.capacityPolicyTips"
            required="true"
            [label]="i18n.capacityPolicy">
            <n-select
                id="create-file-system-capacity-policy"
                [options]="capacityPolicyOptions"
                formControlName="spaceselfAdjustingMode">
            </n-select>
        </n-form-item>
        <ng-container *ngIf="advanced && vm.value.spaceselfAdjustingMode !== CapacityPolicyE.DISABLED">
            <!-- 自动扩容触发门限（%） -->
            <n-form-item [label]="i18n.capacityExpansion"
                [helpContent]="i18n.capacityExpansionTips"
                [maxErrorTip]="str.errorCount"
                required="true">
                <n-spinner id="create-file-system-capacity-expansion"
                    [min]="str.expansionMin"
                    [max]="str.expansionMax"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    formControlName="autoGrowThresholdPercent">
                </n-spinner>
            </n-form-item>
            <!-- 自动缩容触发门限（%） -->
            <n-form-item [label]="i18n.capacityScaleIn"
                *ngIf="vm.value.spaceselfAdjustingMode === CapacityPolicyE.AUTOEXPANSIONANDREDUCTION"
                [helpContent]="i18n.capacityScaleInTips"
                required="true">
                <n-spinner id="create-file-system-capacity-scale-in"
                    [min]="str.scaleInMin"
                    [max]="str.scaleInMax"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    formControlName="autoShrinkThresholdPercent">
                </n-spinner>
            </n-form-item>
            <!-- 自动扩容上限 -->
            <n-form-item [label]="i18n.capacityExpansionLimit"
                [helpContent]="i18n.capacityExpansionLimitTips"
                required="true">
                <div class="interval-10">
                    <n-capacity id="create-file-system-capacity-expansion-limit"
                        style="width: 3rem"
                        [units]="['Sector', 'MB', 'GB', 'TB', 'PB']"
                        [nonDecimalUnits]="notDotUnits"
                        formControlName="maxAutoSize">
                    </n-capacity>
                    <span *ngIf="vm.value.maxAutoSize && vm.value.maxAutoSize.unit === 'Sector'">
                        {{ vm.value.maxAutoSize.value | adaptUnit :'Sector'}}
                    </span>
                </div>
                <n-tip [content]="i18n.maxAutoSizeMsg"></n-tip>
            </n-form-item>
            <!-- 自动缩容下限 -->
            <n-form-item [label]="i18n.capacityScaleInLimit"
                [helpContent]="i18n.capacityScaleInLimitTips"
                *ngIf="vm.value.spaceselfAdjustingMode === CapacityPolicyE.AUTOEXPANSIONANDREDUCTION"
                required="true">
                <div class="interval-10">
                    <n-capacity id="create-file-system-capacity-scale-in-limit"
                        style="width: 3rem"
                        [units]="['Sector', 'MB', 'GB', 'TB', 'PB']"
                        [nonDecimalUnits]="notDotUnits"
                        formControlName="minAutoSize">
                    </n-capacity>
                    <span *ngIf="vm.value.minAutoSize && vm.value.minAutoSize.unit === 'Sector'">
                        {{ vm.value.minAutoSize.value | adaptUnit :'Sector'}}
                    </span>
                </div>
                <n-tip [content]="i18n.minAutoSizeMsg"></n-tip>
            </n-form-item>
        </ng-container>
        <!-- 应用类型 -->
        <n-form-item
            [label]="i18n.workloadTypeLab"
            [required]="true"
            class="custom-width">
            <n-select id="create-file-system-workload-type"
                [options]="workloadTypeOpts"
                formControlName="workloadType"
                (onChange)="onWorkloadTypeChange($event)">
            </n-select>
            <ng-container *ngIf="selectedWorkloadType">
                <p class="sub mt-5">{{i18n.typeLab + workloadCreateTypeMap[selectedWorkloadType.CREATETYPE]}}</p>
                <p *ngIf="!FeatureConfig.IsShowVariableSegmentInFSWorkloadType" class="sub mt-5">{{str.getRequestSizeStrByNum | fn :selectedWorkloadType.BLOCKSIZE}}</p>
                <ng-container *ngIf="!supportGuaranteedCapacity || supportDedupeAndCompression">
                    <p *ngIf="showVariableSegment" class="sub mt-5">{{str.getVariableSegmentSizeStrByNum | fn :selectedWorkloadType.variableSegment}}</p>
                    <p class="sub mt-5" *ngIf="!isCoverageStorHideDedupeAndCompression">{{i18n.smartCompressionLab + (selectedWorkloadType.ENABLECOMPRESS === 'true' ? i18n.enabledLab : i18n.disabledLab)}}</p>
                    <p class="sub mt-5" *ngIf="!isCoverageStorHideDedupeAndCompression">{{i18n.smartDedupLab + (selectedWorkloadType.ENABLEDEDUP === 'true' ? i18n.enabledLab : i18n.disabledLab)}}</p>
                </ng-container>
                <p class="sub mt-5">{{i18n.distributionAlgoLabel + (utilService.getLabelFromOptions | fn :str.DistAlgOpts :selectedWorkloadType.distAlg)}}</p>
            </ng-container>
        </n-form-item>
        <!-- smartcache -->
        <n-form-item *ngIf="advanced && FeatureConfig.IsSupportSmartCache && !SWITCH.IS_VSTORE_SYSTEM" [label]="i18n.smartCachePartitionLab">
            <n-select
                id="add_fs_partition_list_id"
                [options]="smartCachePartionList"
                formControlName="smartCachePartition"
                [clearBtn]="true"
                (onChange)="onSmartCachePartitionChange($event)">
            </n-select>
        </n-form-item>
        <ng-container *ngIf="vstorePairId && entry !== FileSystemEntryE.AuditLog">
            <!-- 文件系统双活, 仅双活租户支持 -->
            <n-form-item [labelHide]="true">
                <div class="title-md mt-32">{{i18n.hyperMetroPairLab}}</div>
            </n-form-item>
            <n-form-item [label]="i18n.remoteVstoreLab">
                <div class="n-form-item-text">{{ remoteVstoreName }}</div>
            </n-form-item>
            <n-form-item [label]="i18n.hyperMetroDomainLab">
                <div class="n-form-item-text">{{ fsHyperMetroDomain?.NAME }}</div>
            </n-form-item>
            <n-form-item [label]="i18n.remoteStoragePollLab" [required]="true">
                <n-select
                    id="remote_storage_poll"
                    [options]="remoteStoragePoolOpts"
                    formControlName="remoteParentId"
                    [filter]="true"
                    style="width: 3rem">
                </n-select>
            </n-form-item>
        </ng-container>
        <!-- 共享 -->
        <n-form-item *ngIf="(entry === FileSystemEntryE.Main || entry === FileSystemEntryE.AuditLog) && hasSharePermission"
            [labelHide]="true">
            <div class="title-md mt-32">{{i18n.shareLab}}</div>
        </n-form-item>
    </form>
    <!-- Copy From 支持new和copy from， 其中new是有默认值的 -->
    <div *ngIf="hasSharePermission">
        <!-- NFS copy from -->
        <!-- 创审计日志文件系统不支持智能GUI -->
        <app-copy-from-nfs-share
            *ngIf="entry === FileSystemEntryE.Main || entry === FileSystemEntryE.AuditLog"
            [vm]="vm"
            [entry]="entry"
            [fsName]="vm.value.name"
            [shareSwitch]="shareSwitch.nfs"
            [smartGuiNfs]="smartGuiNfs"
            [vstoreName]="selectedVstore?.label"
            [vstoreId]="selectedVstore?.value"
            [supportSmartGui]="entry != FileSystemEntryE.AuditLog">
        </app-copy-from-nfs-share>
    </div>

    <div *ngIf="hasSharePermission && !ProductConfig.isHideCifs" class="cifs-copy-from">
        <!-- CIFS copy from -->
        <!-- 创审计日志文件系统不支持智能GUI -->
        <app-copy-from-cifs-share
            *ngIf="entry === FileSystemEntryE.Main || entry === FileSystemEntryE.AuditLog"
            [vm]="vm"
            [entry]="entry"
            [fsName]="vm.value.name"
            [shareSwitch]="shareSwitch.cifs"
            [smartGuiCifs]="smartGuiCifs"
            [vstoreName]="selectedVstore?.label"
            [vstoreId]="selectedVstore?.value"
            [supportSmartGui]="entry != FileSystemEntryE.AuditLog">
        </app-copy-from-cifs-share>
    </div>

    <div *ngIf="hasSharePermission && (FeatureConfig.IsSupportDataTurboWhenNASIsSupported || FeatureConfig.IsSupportDpcWhenNASIsSupported) && tempVstoreValue === '0'" class="dataTurbo-copy-from">
        <!-- dataTurbo copy from -->
        <!-- 创审计日志文件系统不支持智能GUI -->
        <app-copy-from-data-turbo-share
            *ngIf="entry === FileSystemEntryE.Main || entry === FileSystemEntryE.AuditLog"
            [vm]="vm"
            [entry]="entry"
            [fsName]="vm.value.name"
            [shareSwitch]="shareSwitch.dataTurbo"
            [smartGuiDataTurbo]="smartGuiCifs"
            [vstoreName]="selectedVstore?.label"
            [vstoreId]="selectedVstore?.value"
            [supportSmartGui]="entry != FileSystemEntryE.AuditLog">
        </app-copy-from-data-turbo-share>
    </div>

    <!-- 配额 、 配额开关-->
    <div class="title-md mt-32" *ngIf="advanced && entry === FileSystemEntryE.Main">{{i18n.quotaSwitchLab}}
        <n-switch id="create-as-quota" class="ml-10" [(ngModel)]="createQuotaSwitch">
        </n-switch>
    </div>

    <!-- 配额的前台表格 -->
    <div class="quota-table" *ngIf="advanced && entry === FileSystemEntryE.Main">
        <app-front-table-user-quota *ngIf="createQuotaSwitch" [(tableData)]="quotaDatas" [fileSystem]="{'NAME': vm.value.name}"
        [vstoreName]="selectedVstore?.label" [vstoreId]="selectedVstore?.value"></app-front-table-user-quota>
    </div>

    <form [errorMessage]="errorMessage" [formGroup]="vm" class="common-form">
        <!-- 保护 -->
        <ng-container *ngIf="supportCdpSchedule">
            <!-- 保护label -->
            <n-form-item [labelHide]="true">
                <div class="title-md mt-32">{{i18n.fsProtectionLab}}</div>
            </n-form-item>
            <!-- 占位获取表单宽度 -->
            <div #cdpEmptyDiv></div>
            <div class="disply-form-item">
                <div class="disply-form-item-lable">
                    <div #cdpCardDiv>
                        <n-card-panel [class]="'protect-card' + (entry === FileSystemEntryE.Main || data ? ' main-entry' : ' other-entry')">
                            <div slot="title" class="add-to-cdp-switch">
                                <!-- 加入定时计划label -->
                                <h2 class="card-title">{{i18n.addToCdpTitle}}</h2>
                                <!-- 加入定时计划开关 -->
                                <n-switch id="create-file-system-add-to-cdp-switch"
                                    formControlName="addToCdpScheduleSwitch"
                                    (onChange)="cdpScheduleSwitchChange($event)">
                                </n-switch>
                            </div>
                            <form [class.hidden]="!vm.value.addToCdpScheduleSwitch"
                                [errorMessage]="errorMessage"
                                [formGroup]="vm"
                                class="common-form">

                                <n-form-item [label]="i18n.hyperCdpScheduleForFileSystemLab"
                                    style="display: flex;"
                                    [required]="true">
                                    <!-- CDP定时计划下拉框 -->
                                    <n-select #cdpScheduleSelect
                                        id="create-file-system-selected-cdp-schedule"
                                        [rest]="cdpScheduleRest"
                                        labelField="NAME"
                                        valueField="NAME"
                                        [defaultOption]="defaultOption"
                                        [restChangeVerify]="false"
                                        [filter]="!!cdpScheduleRest"
                                        (onChange)="cdpSelectChange($event.option)"
                                        formControlName="selectedCdpSchedule">
                                    </n-select>
                                    <ng-container *ngIf="vm.value.selectedCdpSchedule">
                                        <form class="subText">
                                            <!-- CDP定时计划状态 -->
                                            <ng-container *ngIf="cdpScheduleSelect.selectedOption">
                                                <!-- 无CDP内置定时计划tip -->
                                                <n-form-item
                                                    *ngIf="!defaultCdpSchedule && cdpScheduleSelect.selectedOption.value === defaultScheduleName"
                                                    [labelHide]="true">
                                                    <div style="display: flex;">
                                                        <span class="mt-5" style="word-break: keep-all;">{{str.i18n.noDefaultCdpScheduleTip}}</span>
                                                    </div>
                                                </n-form-item>
                                                <n-form-item
                                                    *ngIf="!(!defaultCdpSchedule && cdpScheduleSelect.selectedOption.value === defaultScheduleName)"
                                                    [label]="str.i18n.statusLab">
                                                    <span class="mt-5" nTextTips>{{statusRender | fn :cdpScheduleSelect.selectedOption.data?.RUNNINGSTATUS}}</span>
                                                </n-form-item>
                                            </ng-container>
                                            <!-- CDP定时计划策略 -->
                                            <n-form-item
                                                *ngFor="let sty of cdpScheduleSelect?.selectedOption?.data?.strategy; index as i"
                                                [label]="i === 0 ? str.i18n.strategyLab : ''">
                                                <div style="display: flex;">
                                                    <span class="tipsText mt-5" nTextTips>{{sty}}</span>
                                                </div>
                                            </n-form-item>
                                        </form>
                                    </ng-container>
                                    <!-- block用于把界面撑开防止策略长度不一样导致下拉框位置不同 -->
                                    <span class="cdpBlock"></span>
                                </n-form-item>
                            </form>
                        </n-card-panel>
                    </div>
                </div>
            </div>

        </ng-container>
        <!-- 防病毒 -->
        <ng-container *ngIf="showAntivirus">
            <n-form-item [labelHide]="true">
                <!-- 防病毒label -->
                <div class="title-md mt-32">{{i18n.antivirusTitle}}</div>
                <!-- 防病毒后台策略卡片 -->
                <div class="mb-20 mt-20">
                    <app-create-fs-scan-mission-policy-card #ondemandCard
                        [fsId]="data && data.ID"
                        [isTemplateCreate]="data"
                        [vstoreId]="tempVstoreValue"
                        [vm]="vm"
                        [type]="ScanPolicyTypeE.ONDEMAND">
                    </app-create-fs-scan-mission-policy-card>
                </div>
                <!-- 防病毒实时策略卡片 -->
                <div>
                    <app-create-fs-scan-mission-policy-card #onaccessCard
                        [fsId]="data && data.ID"
                        [isTemplateCreate]="data"
                        [vstoreId]="tempVstoreValue"
                        [vm]="vm"
                        [type]="ScanPolicyTypeE.ONACCESS">
                    </app-create-fs-scan-mission-policy-card>
                </div>
            </n-form-item>
        </ng-container>
        <!-- 审计日志 -->
        <ng-container *ngIf="advanced && entry !== FileSystemEntryE.AuditLog && hasAuditStrategyW">
            <n-form-item [labelHide]="true">
                <div class="audit-log-disabled-tip sub mt-32">
                    <div class="title-md">{{i18n.auditLogLab}}</div>
                    <n-tip *ngIf="!isAuditLogEnabled || FeatureConfig.IsSupportDataTurboWhenNASIsSupported || FeatureConfig.IsSupportDpcWhenNASIsSupported" type="info"></n-tip>
                    <ng-container *ngIf="!isAuditLogEnabled">
                        <span>{{i18n.auditLogdisabledTipLab}}</span>
                        <button nButton
                            theme="text"
                            class="enable-audit-log-btn"
                            [ngClass]="{'enable-audit-log-btn-en': language === 'en'}"
                            [label]="i18n.enableAuditLogBtn"
                            (click)="jumpToAuditLog(selectedVstore.value)">
                        </button>
                        <span>{{i18n.preiodLab}}</span>
                    </ng-container>
                </div>
                <!-- 二级存储专用的dataTurbo提示 -->
                <span *ngIf="FeatureConfig.IsSupportDataTurboWhenNASIsSupported || FeatureConfig.IsSupportDpcWhenNASIsSupported" class="sub va-top">{{notSupportDataTurboTip}}</span>
            </n-form-item>
            <n-form-item [labelHide]="true">
                <div class="mb-5">{{i18n.auditLogLabTip}}</div>
                <n-checkbox-group
                    id="audit-log-items"
                    formControlName="auditItems">
                    <n-checkbox
                        *ngFor="let item of auditItemOpt; let i = index"
                        [ngClass]="'audit-items-checkbox-col-' + i % 3"
                        [label]="item.label"
                        [value]="item.value">
                    </n-checkbox>
                </n-checkbox-group>
            </n-form-item>
        </ng-container>
        <!-- 属性 -->
        <ng-container *ngIf="advanced">
            <!-- 属性 -->
            <n-form-item [labelHide]="true">
                <div class="title-md mt-32">{{i18n.fsPropertyLab}}</div>
            </n-form-item>
            <!-- 快照目录是否可见 -->
            <n-form-item [label]="i18n.isShowSnapshotDirLab"
                [required]="true"
                *ngIf="!ProductConfig.isHideFsSnapshotFeature">
                <n-select id="create-file-system-is-show-snapshot-dir"
                    [options]="str.showSnapshotDirOpts"
                    formControlName="isShowSnapshotDir">
                </n-select>
            </n-form-item>
            <!-- 自动更新Atime -->
            <n-form-item [label]="i18n.atimeLab">
                <n-checkbox id="create-file-system-atime"
                    formControlName="atime"
                    [label]="i18n.enable">
                </n-checkbox>
            </n-form-item>
            <!-- 快照对比功能 -->
            <n-form-item [label]="i18n.snapCompare" [helpContent]="i18n.snapCompareTip" *ngIf="ProductConfig.isSupportSnapDiffSwitch">
                <n-checkbox id="create-file-system-snap-diff-switch"
                    formControlName="snapDiffSwitch"
                    [label]="i18n.enable">
                </n-checkbox>
            </n-form-item>
            <n-form-item *ngIf="vm.value.atime"
                [label]="i18n.atimeUpdateModeLab"
                [required]="true">
                <n-select id="create-file-system-atime-update-mode"
                    [options]="str.atimeUpdateModeOpts"
                    formControlName="atimeUpdateMode">
                </n-select>
            </n-form-item>
        </ng-container>
    </form>

    <!-- worm-->
    <section [hidden]="checkWormShow | fn :vstorePairId :advanced">
        <!-- 开关 -->
        <div class="title-md mt-32">
            <span>{{i18n.worm.title}}</span>
            <n-switch id="worm-switch-id"
                class="ml-10"
                [(ngModel)]="wormSwitch"
                (onChange)="wormSwitchChange($event)">
            </n-switch>
        </div>
        <n-tip *ngIf="wormSwitch && (vm.value.atime || vm.value.vaaiSwitch)"
            type="warning"
            [content]="wormSwitchTip">
        </n-tip>
        <!-- worm主体 -->
        <app-worm-config-card #wormConfig
            *ngIf="wormSwitch"
            [wormObj]="data"
            [globalClockInitialized]="wormClockInited"
            [loading]="clockLoading"
            [action]="ActionE.Create"
            [isHyperMetroPairWorm]="vstorePairId !== undefined && vstorePairId !== null">
        </app-worm-config-card>
    </section>
    <!-- 根目录权限 -->
    <section [hidden]="!advanced || vm.value.securityStyle === SecurityModeE.NTFS">
        <app-unix-permission-config #unixPermissionConfig
            [actionType]="UnixConfigCardActionTypeE.CREATE"
            [entryType]="UnixConfigCardEntryTypeE.FILESYSTEM"
            [dtreeOrFsData]="data">
        </app-unix-permission-config>
    </section>
    <n-footer>
        <button id="create-file-system-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="create-file-system-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
